<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,

        props: {
            dateRanges: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            loading: false,
            chartdata: {
                labels: [],
                datasets: [
                    {
                        label: '10 อันดับสินค้าที่แลกมากที่สุด',
                        backgroundColor: '#6d9aee',
                        data: []
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        }),

        watch: {
            dateRanges: {
                deep: true,
                handler({fromDate, toDate}) {
                    this.load({fromDate, toDate})
                }
            }
        },

        async mounted () {
            try {
                await this.load(this.$props.dateRanges)
            } catch (e) {

            }
        },

        methods: {
            async load({fromDate, toDate}) {
                this.loading = true

                try {
                    const { data } = await axios.get(`/reports/top-products`, {
                        params: {
                            from_date: fromDate,
                            to_date: toDate
                        }
                    })

                    const labels = [];
                    const items = [];

                    data.data.forEach((item) => {
                        // Limit string display
                        if(item.description.length > 10) {
                            item.description = item.description.substring(0, 20);
                        }

                        labels.push(item.description)
                        items.push(item.sum_qty)
                    })

                    this.chartdata.labels = labels
                    this.chartdata.datasets[0].data = items

                    this.renderChart(this.chartdata, this.options)

                } catch (e) {
                    //
                }

                this.loading = false
            }
        }
    }
</script>
